import { initializeDetector, destroyDetector } from "@/utils/updateVersionUtil.js";
export default {
  mounted() {
    // 初始化版本检测（每3分钟检查一次）
    initializeDetector();
  },
  beforeUnmount() {
    destroyDetector();
  }
};